<template>
  <div class="col-6 col-md filter-container dates-filter">
    <h4>{{ I18n.t('search_page.artworks_tab.filters.date.title') }}</h4>
    <p>{{ I18n.t('search_page.artworks_tab.filters.date.labels.from') }}:</p>
    <Datepicker :key="dateFromValue" v-model="datepickerFrom" @focus="hideSecondPopup"
                @change="changeDateFromFilter($event)" :first-day-of-week="1" :lang="lang"
                format="DD-MM-YYYY" :editable="false" class="input-cont"></Datepicker>
    <p>{{ I18n.t('search_page.artworks_tab.filters.date.labels.to') }}:</p>
    <Datepicker :key="dateToValue" v-model="datepickerTo" @focus="addClassToFilterBox"
                @change="changeDateToFilter($event)" :first-day-of-week="1" :lang="lang"
                format="DD-MM-YYYY" :editable="false" id="datepickerTo" class="input-cont"></Datepicker>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Datepicker from 'vue2-datepicker';
  import FormatDate from '@/shared/mixins/format_date';
  import { ARTWORKS_FILTERS, DATEPICKER_LANG } from '../../../consts';

  export default {
    name: 'DateFilterColumn',
    data() {
      return {
        lang: DATEPICKER_LANG,
        dateFromPath: ARTWORKS_FILTERS.DATES.FROM.PATH,
        dateToPath: ARTWORKS_FILTERS.DATES.TO.PATH,
        datepickerFrom: '',
        datepickerTo: '',
      };
    },
    mixins: [FormatDate],
    components: {
      Datepicker,
    },
    computed: {
      ...mapGetters(['filterValue']),
      dateFromValue() {
        const date = this.filterValue(this.dateFromPath);
        if (!date) this.datepickerFrom = '';
        return date;
      },
      dateToValue() {
        const date = this.filterValue(this.dateToPath);
        if (!date) this.datepickerTo = '';
        return date;
      },
    },
    methods: {
      ...mapActions(['getArtworksWhenFilterIsChanging']),
      changeDateFromFilter(currentValue) {
        this.getArtworksWhenFilterIsChanging(
          { path: this.dateFromPath, value: this.formatDateToQueryString(currentValue) },
        );
      },
      changeDateToFilter(currentValue) {
        this.getArtworksWhenFilterIsChanging(
          { path: this.dateToPath, value: this.formatDateToQueryString(currentValue) },
        );
      },
      formatDateToQueryString(date) {
        if (date == null) return null;
        return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
      },
      setCorrectDateFormat(initialDate) {
        let date = initialDate;
        if (!date) return '';
        date = this.formatDate(date);
        date = new Date(date.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
        return date;
      },
      setDatepickerInitialDate() {
        this.datepickerFrom = this.setCorrectDateFormat(this.dateFromValue);
        this.datepickerTo = this.setCorrectDateFormat(this.dateToValue);
      },
      addClassToFilterBox() {
        document.getElementById('vueSlideToggle').classList = 'filters__modal overflow-visible';
      },
      hideSecondPopup() {
        const secondPopup = document.getElementById('datepickerTo').lastChild;
        secondPopup.style.display = 'none';
        this.addClassToFilterBox();
      },
    },
    mounted() {
      this.setDatepickerInitialDate();
    },
  };
  Datepicker.methods.displayPopup = function setPosition() {
    this.position = {
      left: 0,
      top: '100%',
    };
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/filters/date_filter_column.vue?7116fa26